import { CustomerUrl } from '../../../../types';
import { ErrorResponse } from '../../../../types/interface/error.interface';

import { ProfileState, TeamSettings, UpdateUserDetails } from './profile.state';

export const RESET_PROFILE_ERROR = 'RESET_PROFILE_ERROR';
export const RESET_PROFILE_RESPONSE = 'RESET_PROFILE_RESPONSE';

export const FETCH_PROFILE_API = 'FETCH_PROFILE_API';
export const FETCH_PROFILE_SUCCESS_API = 'FETCH_PROFILE_SUCCESS_API';
export const FETCH_PROFILE_FAILURE_API = 'FETCH_PROFILE_FAILURE_API';

export const UPDATE_PROFILE_PICTURE_API = 'UPDATE_PROFILE_PICTURE_API';
export const UPDATE_PROFILE_PICTURE_SUCCESS_API = 'UPDATE_PROFILE_PICTURE_SUCCESS';
export const UPDATE_PROFILE_PICTURE_FAILURE_API = 'UPDATE_PROFILE_PICTURE_FAILURE';

export const UPDATE_PROFILE_API = 'UPDATE_PROFILE_API';
export const UPDATE_PROFILE_SUCCESS_API = 'UPDATE_PROFILE_SUCCESS_API';
export const UPDATE_PROFILE_FAILURE_API = 'UPDATE_PROFILE_FAILURE_API';

export const UPDATE_TEAM_SETTINGS_API = 'UPDATE_TEAM_SETTINGS_API';
export const UPDATE_TEAM_SETTINGS_SUCCESS_API = 'UPDATE_TEAM_SETTINGS_SUCCESS_API';
export const UPDATE_TEAM_SETTINGS_FAILURE_API = 'UPDATE_TEAM_SETTINGS_FAILURE_API';

export const REMOVE_TEAM_FROM_PROFILE = 'REMOVE_TEAM_FROM_PROFILE';

export const RESET_STORAGE_PROFILE = 'RESET_STORAGE_PROFILE';

export const resetProfileStorage = (): { type: string } => {
  return {
    type: RESET_STORAGE_PROFILE,
  };
};

export const resetProfileError = (): { type: string } => {
  return {
    type: RESET_PROFILE_ERROR,
  };
};
export const resetProfileResponse = (): { type: string } => {
  return {
    type: RESET_PROFILE_RESPONSE,
  };
};

export const fetchProfileApi = (payload?: boolean): { type: string; payload: boolean } => {
  return {
    type: FETCH_PROFILE_API,
    payload,
  };
};

export const fetchProfileSuccessApi = (
  payload: ProfileState,
): { type: string; payload: ProfileState } => {
  return {
    type: FETCH_PROFILE_SUCCESS_API,
    payload,
  };
};

export const fetchProfileFailureApi = (
  payload: ErrorResponse | any,
): { type: string; payload: ErrorResponse | any } => {
  return {
    type: FETCH_PROFILE_FAILURE_API,
    payload,
  };
};

export const removeTeamFromProfile = (
  teamUuid: string,
): { type: string; payload: { teamUuid: string } } => {
  return {
    type: REMOVE_TEAM_FROM_PROFILE,
    payload: { teamUuid },
  };
};

export const updateProfileApi = (
  payload: UpdateUserDetails,
): { type: string; payload: UpdateUserDetails } => {
  return {
    type: UPDATE_PROFILE_API,
    payload,
  };
};

export const updateProfileSuccessApi = (
  payload: ProfileState,
): { type: string; payload: ProfileState } => {
  return {
    type: UPDATE_PROFILE_SUCCESS_API,
    payload,
  };
};

export const updateProfileFailureApi = (
  payload: ErrorResponse | any,
): { type: string; payload: ErrorResponse | any } => {
  return {
    type: UPDATE_PROFILE_FAILURE_API,
    payload,
  };
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const updateProfilePicApi = (payload: any): { type: string; payload: any } => {
  return {
    type: UPDATE_PROFILE_PICTURE_API,
    payload,
  };
};

export const updateProfilePicSuccessApi = (
  payload: CustomerUrl,
): { type: string; payload: CustomerUrl } => {
  return {
    type: UPDATE_PROFILE_PICTURE_SUCCESS_API,
    payload,
  };
};

export const updateProfilePicFailureApi = (
  payload: ErrorResponse | any,
): { type: string; payload: ErrorResponse | any } => {
  return {
    type: UPDATE_PROFILE_PICTURE_FAILURE_API,
    payload,
  };
};

export const updateTeamSettingsApi = (
  payload: TeamSettings,
): { type: string; payload: TeamSettings } => {
  return {
    type: UPDATE_TEAM_SETTINGS_API,
    payload,
  };
};

export const updateTeamSettingsSuccessApi = (
  payload: TeamSettings,
): { type: string; payload: TeamSettings } => {
  return {
    type: UPDATE_TEAM_SETTINGS_SUCCESS_API,
    payload,
  };
};

export const updateTeamSettingsFailureApi = (
  payload: ErrorResponse | any,
): { type: string; payload: ErrorResponse | any } => {
  return {
    type: UPDATE_TEAM_SETTINGS_FAILURE_API,
    payload,
  };
};
